import { ReactNode, useMemo } from 'react';

import { MaintenancePage } from '@/pages/MaintenancePage';

import { useInitSettings } from '@/entities/user/currentUser';

import { Loader } from '@/shared/ui/Loader';

import { IS_MAINTENANCE_DISABLED } from '../config';

type MaintenanceContainerProps = {
  children: ReactNode;
};

export const MaintenanceContainer = ({ children }: MaintenanceContainerProps) => {
  const { data, error, isPending } = useInitSettings();

  const isMaintenance = useMemo(
    () => error || (data?.features?.maintenance && !IS_MAINTENANCE_DISABLED),
    [data?.features?.maintenance, error],
  );

  if (isMaintenance) {
    return <MaintenancePage />;
  }

  if (isPending) {
    return <Loader />;
  }

  return children;
};
